import { initialCompanyInfo } from "../constants/companyInfo";
import { Types } from "../actions/companyInfo";

export const companyInfoReducer = (state = initialCompanyInfo, action) => {
  const { type, payload } = action;

  switch (type) {
    case Types.SET_COMPANY_INFO:
      return {
        ...state,
        company_name: payload?.company_name,
        logo: payload?.logo,
        orgID: payload?.orgID,
        loading: false,
        tracking_page_details: payload?.tracking_page_details,
      };

    case Types.INITIATE_API_CALL:
      return {
        ...state,
        loading: true,
      };
      case Types.SET_SHOW_REPORT:
        return{
          ...state,
          showreport:payload?.showreport,
        }

    default:
      return state;
  }
};
